export const getProduct = (id) => {
    return{
        type:"GET_PRODUCT",
        id
    }
};
